// extracted by mini-css-extract-plugin
export default {"current":"bs_gB","update":"bs_gC","showColors":"bs_gD","positive":"bs_gF","negative":"bs_gG"};